import script from "./TheDocumentInvite.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDocumentInvite.vue?vue&type=script&setup=true&lang=js"

import "./TheDocumentInvite.vue?vue&type=style&index=0&id=b579b27c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b579b27c"]])

export default __exports__